/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import APITokens from 'ui/pages/user/APITokens.vue';
import { PRODUCTION_APP_ROOT_DOMAIN } from 'libs/utils/constants';

/**
 * This component is used to nicely display APIs security features.
 *
 * @vue-prop {Object[]} [security] a list of security objects
 * @vue-prop {Object[]} [secDefinitions] a list of security definition objects
 * @vue-data {Boolean} hasSecurityDefinitions whether the gathered document has security definitions set or it's empty
 *
 * @category docs.components.apis
 * @exports Security
 * @component
 */
const __vue_script__ = {
    name: 'Security',

    components: { APITokens },

    data() {
        return {
            currentTab: 'javascript',
            loading: true,
            showTokens: false,
            apiRootDomain: `https://api${PRODUCTION_APP_ROOT_DOMAIN}`
        };
    },

    async created() {

        try {
            const { data } = await this.$services.session.getSession();

            if (data.authenticated) {
                this.showTokens = true;
            }
        } catch (error) {
            console.info('[Security] User could not be authenticated, showing instructions');
        } finally {
            this.loading = false;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"security"},[_vm._m(0),_c('div',{attrs:{"id":"obtain-token"}},[_c('h2',[_vm._v("Obtaining a token")]),_c('loader',{staticClass:"in-page",attrs:{"status":_vm.loading}},[(!_vm.loading && _vm.showTokens)?_c('div',{staticClass:"user-tokens"},[_c('APITokens')],1):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && !_vm.showTokens),expression:"!loading && !showTokens"}],staticClass:"instructions"},[_c('p',[_vm._v("Login to backstage and click on your name on the user menu:")]),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/user_menu.jpg'),"srcset":_vm.$utils.assets.imagePath('api-docs/user_menu.jpg', '3x'),"alt":"user menu"}})]),_c('p',[_vm._v("Click on API tokens and then on 'Create a token' button in the bottom of the page:")]),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/api_tokens.jpg'),"srcset":_vm.$utils.assets.imagePath('api-docs/api_tokens.jpg', '3x'),"alt":"user menu"}})]),_c('p',[_vm._v("A popup will show prompting for an identifier for your new token. The application name is a good candidate. Click on 'Create':")]),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/create.jpg'),"srcset":_vm.$utils.assets.imagePath('api-docs/create.jpg', '3x'),"alt":"user menu"}})]),_c('p',[_vm._v("A new popup with your new token will be shown. Please note that this will be the only time you will ever see your token,\nso, please take note of it in a secure place:")]),_c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.$utils.assets.imagePath('api-docs/token.jpg'),"srcset":_vm.$utils.assets.imagePath('api-docs/token.jpg', '3x'),"alt":"user menu"}})])])])],1),_c('div',{attrs:{"id":"using-token"}},[_c('h2',[_vm._v("Using the token")]),_c('p',[_vm._v("Now that you have a valid token you can make authorized requests as follow:")]),_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item",class:{active: (_vm.currentTab == "javascript")}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.currentTab = "javascript"}}},[_vm._v("Javascript")])]),_c('li',{staticClass:"nav-item",class:{active: (_vm.currentTab == "curl")}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.currentTab = "curl"}}},[_vm._v("Curl")])]),_c('li',{staticClass:"nav-item",class:{active: (_vm.currentTab == "ruby")}},[_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.currentTab = "ruby"}}},[_vm._v("Ruby")])])]),_c('pre',{directives:[{name:"code-highlight",rawName:"v-code-highlight"},{name:"show",rawName:"v-show",value:(_vm.currentTab === 'javascript'),expression:"currentTab === 'javascript'"}],staticClass:"example javascript"},[_vm._v("| const myToken = 'token';\n| const url = '"+_vm._s((_vm.apiRootDomain + "/api/v2/me"))+"';\n| // Using `fetch`\n| fetch(url, {\n|    headers: {\n|        'Authorization': `Bearer ${myToken}`\n|    }\n| });\n| // Using Axios.js ( https://github.com/axios/axios )\n| $axios.get(url, {\n|    headers: {\n|        'Authorization': `Bearer ${myToken}`\n|    }\n| });")]),_c('pre',{directives:[{name:"code-highlight",rawName:"v-code-highlight"},{name:"show",rawName:"v-show",value:(_vm.currentTab === 'curl'),expression:"currentTab === 'curl'"}],staticClass:"example bash"},[_vm._v("| curl -H \"Accept: application/json\" -H \"Authorization: Bearer ${TOKEN}\" "+_vm._s((_vm.apiRootDomain + "/api/v2/me ")))]),_c('pre',{directives:[{name:"code-highlight",rawName:"v-code-highlight"},{name:"show",rawName:"v-show",value:(_vm.currentTab === 'ruby'),expression:"currentTab === 'ruby'"}],staticClass:"example ruby"},[_vm._v("| require \"net/http\"\n| require \"uri\"\n| token = \"token\"\n| uri = URI.parse(\""+_vm._s((_vm.apiRootDomain + "/api/v2/me "))+"\")\n| http = Net::HTTP.new(uri.host, uri.port)\n| request = Net::HTTP::Get.new(uri.request_uri)\n| request[\"Authorization\"] = \"Bearer #{token}\"\n| response = http.request(request)")])])])}
var __vue_staticRenderFns__ = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"intro"}},[_c('h2',[_vm._v("Authentication")]),_c('p',[_vm._v("SpotMe uses "),_c('strong',[_vm._v("Bearer authentication")]),_vm._v(" for protected API calls.")]),_c('p',[_c('strong',[_vm._v("Bearer authentication")]),_vm._v(" (also called"),_c('strong',[_vm._v(" token authentication")]),_vm._v(") is an HTTP authentication scheme that involves security tokens called bearer tokens and was originally created as part of "),_c('a',{attrs:{"href":"https://oauth.net/2/","target":"_blank"}},[_vm._v("OAuth 2.0.")]),_vm._v(" The name \"Bearer authentication\" can be understood as \"give access to the bearer of this token.\"\n The bearer token is a cryptic string, generated from the backstage user as described below.\n The API client must send this token in the Authorization header when making requests to protected resources:")]),_c('pre',[_vm._v("Authorization: Bearer <token>")])])}]

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Security.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__